const getters = {
  language: state => state.language,
  buckets: state => state.buckets,
  routers: state => state.routers,
  userRouters: state => state.userRouters,
  userInfo: state => state.userInfo,
  categories: state => state.categories,
  channels: state => state.channels,
  appModal: state => state.popup.appModal,
  addPopup: state => state.popup.addPopup,
  addChannelPopup: state => state.popup.addChannelPopup,
  addPopupImg: state => state.popup.addPopupImg,
  addBooks: state => state.popup.addBooks,
  addRootNodeBooks: state => state.popup.addRootNodeBooks,
  addEditRootNodeBooks: state => state.popup.addEditRootNodeBooks,
  delPopup: state => state.popup.delPopup,
  showAddBooksList: state => state.popup.showAddBooksList,
  showRefreshBooksList: state => state.popup.showRefreshBooksList,
  delFacility: state => state.popup.delFacility,
  appendPopup: state => state.popup.appendPopup,
  macPopup: state => state.popup.macPopup,
  showCreateOrg: state => state.popup.showCreateOrg,
  showPushChannel: state => state.popup.showPushChannel,
  showClassifyEditBoobsLis: state => state.popup.showClassifyEditBoobsLis,
  showClassifyEditBoobs: state => state.popup.showClassifyEditBoobs,
  showDateTimePicker: state => state.popup.showDateTimePicker,
  showAddBookList: state => state.popup.showAddBookList,
  showBatchUpload: state => state.popup.showBatchUpload,
  showClassifyEdit: state => state.popup.showClassifyEdit,
  hasData: state => state.hasData,
  navCtrl: state => state.navCtrl,
  //获取全选状态
  selectShow: state => state.selectShow,
  setOverallShow: state => state.setOverallShow,
  setHandleShow: state => state.setHandleShow,
  imMsgList: state => state.imMsgList,
  imSessionList: state => state.imSessionList,
  ctrlItem: state => state.ctrlItem,
  cbUserList: state => state.cbUserList,
  cbMsgList: state => state.cbMsgList,
  cbCurrentUser: state => state.cbCurrentUser,
};
export default getters;
